import React from 'react';

// V70.94 — Deploy sonrası BAYAT CHUNK kendi kendini onarır (ChunkLoadError fix).
// Hızlı ardışık deploy'larda tüm chunk hash'leri değişir; deploy ÖNCESİNDEN açık
// kalan bir sekme lazy bir rotaya ilk kez girince ESKİ hash'i ister → 404 →
// React.lazy fırlatır → rota boş kalır ("flight-search açılmıyor", 23.07.2026).
// Çözüm: dinamik import düşerse sayfa BİR KEZ tam yenilenir (index no-cache —
// taze index + güncel hash'ler gelir); başarılı yüklemede bayrak temizlenir.
// İkinci ardışık düşüşte hata yukarı fırlar (gerçek kesinti gizlenmez).
const lazyRetry = (factory) => React.lazy(() => {
  const key = 'chunk_reload:' + window.location.pathname;
  return factory()
    .then((mod) => { try { sessionStorage.removeItem(key); } catch {} return mod; })
    .catch((err) => {
      let alreadyTried = false;
      try { alreadyTried = sessionStorage.getItem(key) === '1'; } catch {}
      if (!alreadyTried) {
        try { sessionStorage.setItem(key, '1'); } catch {}
        window.location.reload();
        return new Promise(() => {}); // reload gelene dek askıda — hata ekranı çakmasın
      }
      try { sessionStorage.removeItem(key); } catch {}
      throw err;
    });
});

export default lazyRetry;
